export default "/images/shield.svg?ca445c49ca56f184dcf84b02e0bdcf53";